import axios from "axios";
import { baseUrl } from "../../config/clientsConfig";


const CheckInAndCheckOutService = {
    getData: async (userId, date) => {
        return axios.get(`${baseUrl}/analytics/attendance?userId=${userId}&date=${date}` );

    }
}
export default CheckInAndCheckOutService;